import React from "react";

import { withTranslation } from "react-i18next";

class FixedPlugin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
    this.containerRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (!this.state.isOpen) return;

    const container = this.containerRef.current;
    if (container && !container.contains(event.target)) {
      this.closePanel();
    }
  }

  closePanel = () => {
    this.setState({ isOpen: false });
  };

  togglePanel = () => {
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  };

  render() {
    const { t, bgColor, theme } = this.props;
    const { isOpen } = this.state;
    const isDarkAppTheme = theme === "dark";
    const dropdownClasses = `dropdown show-dropdown${isOpen ? " show" : ""}`;
    const rootClasses = `fixed-plugin${isDarkAppTheme ? " fixed-plugin--inverted" : ""}`;

    return (
      <div className={rootClasses} ref={this.containerRef}>
        <div className={dropdownClasses}>
          <div onClick={this.togglePanel} role="button" tabIndex={0} aria-expanded={isOpen}>
            <i className="icon-laino-theme" />
          </div>
          <ul className="dropdown-menu show">
            <li className="header-title">{t("fixedPlugin.uiTheme")}</li>
            <li className="adjustments-line">
              <div className="badge-colors text-center">
                <span
                  className={
                    bgColor === "primary"
                      ? "badge filter badge-primary active"
                      : "badge filter badge-primary"
                  }
                  data-color="primary"
                  onClick={() => {
                    this.props.handleBgClick("primary");
                  }}
                />{" "}
                <span
                  className={
                    bgColor === "second"
                      ? "badge filter badge-info active"
                      : "badge filter badge-info"
                  }
                  data-color="second"
                  onClick={() => {
                    this.props.handleBgClick("second");
                  }}
                />{" "}
                <span
                  className={
                    bgColor === "third"
                      ? "badge filter badge-warning active"
                      : "badge filter badge-warning"
                  }
                  data-color="third"
                  onClick={() => {
                    this.props.handleBgClick("third");
                  }}
                />{" "}
              </div>
            </li>
            <li className="adjustments-line text-center color-change">
              <span className="color-label">{t("fixedPlugin.lightMode")}</span>{" "}
              <span
                className="badge light-badge mr-2"
                onClick={() => this.props.activateMode("light")}
              />{" "}
              <span
                className="badge dark-badge ml-2"
                onClick={() => this.props.activateMode("dark")}
              />{" "}
              <span className="color-label">{t("fixedPlugin.darkMode")}</span>{" "}
            </li>
          </ul>
        </div>
      </div>
    );
  }
}
export default withTranslation()(FixedPlugin);
